export * from './batchHttpLink';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/apollo-link-batch-http/lib/index.js
// module id = 3kyw
// module chunks = 20 21